import Link from "next/link";
import { Card, Container, Row } from "reactstrap";
import styles from "./styles.module.scss";

export const ImageButton = ({ className, content, post, sectionId }) => {
  return (
    <section id={sectionId} className={`${styles.root} ${className} py-1`}>
      <Container>
        {content ? (
          <div className="mb-5 text-center">
            <div dangerouslySetInnerHTML={{ __html: content }} />
          </div>
        ) : null}
        <Row className="wrapper flex-wrap text-center justify-content-center">
          {post?.map((post, index) => (
            <Link href={`${post?.buttonLink}`}>
              <Card key={index} className="bg-transparent border-0">
                <div className="mb-4 overflow-hidden rounded-4">
                  <img
                    src={
                      post?.image?.url
                        ? post?.image?.url
                        : "/site-assets/placeholders/img-placeholder.jpg"
                    }
                    alt={post?.image?.alt}
                    className="card-img"
                  />
                  <p className="fs-5">
                    <strong>{post?.buttonTitle}</strong>
                  </p>
                </div>
              </Card>
            </Link>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default ImageButton;
